import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface TCPAWarningProps {
  message: string;
  className?: string;
}

export const TCPAWarning: React.FC<TCPAWarningProps> = ({ 
  message, 
  className = '' 
}) => {
  if (!message) return null;

  return (
    <div className={`flex items-start gap-2 p-3 bg-amber-50 border border-amber-200 rounded-lg text-sm text-amber-800 ${className}`}>
      <AlertTriangle className="h-4 w-4 mt-0.5 flex-shrink-0" />
      <div className="flex-1">
        <p className="font-medium mb-1">TCPA Compliance Notice</p>
        <p className="text-amber-700 leading-relaxed">{message}</p>
      </div>
    </div>
  );
};

export default TCPAWarning;